<template>
	<modal class="mark-refunded-modal" size="small-medium" :hide-footer="true" @close="close">
		<div slot="header">
			<h3>Refund Order</h3>
		</div>
		<div slot="body">
			<div class="mark-complete-content text-center" v-if="selectedSubmission">
				<p>Mark Order ID <span class="text-bold">#{{ selectedSubmission.order_id }}</span> to be refunded <span v-if="isRefundCredit">and Refund (Credit & Commission) to Seller ?</span></p>
				<button type="button" class="mark-complete-button btn btn-default btn-icon"
					:class="{ 'is-loading': isChangingStatus }" @click="confirm">
					<i class="material-icons">sentiment_very_dissatisfied</i><span>Refund</span>
				</button>
			</div>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	name: 'ModalConfirmRefund',
	components: {
		Modal,
	},
	props: {
		isChangingStatus: {
			type: Boolean,
		},
		selectedSubmission: {
			type: Object,
		},
		isRefundCredit: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		confirm() {
			this.$emit('confirm', this.selectedSubmission);
		},
	},
};
</script>
